// import { Suspense, lazy, useEffect, useState } from 'react';
import { Suspense, lazy, useEffect, useState, startTransition } from 'react';

import { Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// import ECommerce from './pages/Dashboard/ECommerce';
// import SignIn from './pages/Authentication/SignIn';
// import SignUp from './pages/Authentication/SignUp';
const Home = lazy(() => import('./pages/Home.jsx'));

import Loader from './common/Loader';
import routes from './routes';
// import Calendar from './pages/Specificationslaw';
// import DataProvider from "./context/DataProvider";
import DataProvider from './context/DataProvider';
// import { DataContext } from './context/DataProvider';

const DefaultLayout = lazy(() => import('./layout/DefaultLayout'));

import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const [loading, setLoading] = useState<boolean>(true);
  // const {edame}= useContext(DataContext)
  useEffect(() => {
    // startTransition(() => {
    //   setTimeout(() => setLoading(false), 1000);
    // });
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <ErrorBoundary>
      <DataProvider>
        <Suspense fallback={<Loader />}>
          <Toaster
            position="top-right"
            reverseOrder={false}
            containerClassName="overflow-auto"
          />
          <Routes>
            <Route element={<DefaultLayout />}>
              <Route path="/" element={<Home />} />
              {/* <Route path="/auth/signup" element={<SignUp />} /> */}
              {/* <Route path='/particulars' element={<Calendar />} /> */}
              {routes.map((routes, index) => {
                const { path, component: Component } = routes;
                return (
                  <Route
                    key={index}
                    path={path}
                    element={
                      // <Suspense fallback={<Loader />}>
                      <Component />
                      // </Suspense>
                    }
                  />
                );
              })}
            </Route>
          </Routes>
        </Suspense>
      </DataProvider>
    </ErrorBoundary>
  );
}

export default App;
